export const SCRIPT_FEEDBACK_CLEAR = 'SCRIPT_FEEDBACK_CLEAR';
export const SCRIPT_FEEDBACK_SET = 'SCRIPT_FEEDBACK_SET';